function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import { StyledAnimatedIconsGridComponent } from "./animated-icons-grid-component.scss";
import AnimatedIcon from "./animated-icon/animated-icon";
const AnimatedIconsGridComponent = (props)=>{
    // isInView is a prop we get from the visibility sensor in base-layout-segment-component.js
    const { iconsArray, isInView } = props;
    return /*#__PURE__*/ _jsx(StyledAnimatedIconsGridComponent, {
        className: "animated-icons-grid-component",
        children: /*#__PURE__*/ _jsx("div", {
            className: "icons-container",
            children: iconsArray === null || iconsArray === void 0 ? void 0 : iconsArray.map((icon, index)=>{
                return /*#__PURE__*/ _jsx("div", {
                    className: "icon-container",
                    children: /*#__PURE__*/ _jsx(AnimatedIcon, _object_spread_props(_object_spread({
                        iconAsset: icon === null || icon === void 0 ? void 0 : icon.iconAsset
                    }, icon), {
                        startAnimation: isInView
                    }))
                }, index);
            })
        })
    });
};
export default AnimatedIconsGridComponent;
